import { render } from "./DestinationsResult.vue?vue&type=template&id=01edd845"
import script from "./DestinationsResult.vue?vue&type=script&lang=js"
export * from "./DestinationsResult.vue?vue&type=script&lang=js"
script.render = render

export default script